module.exports = __webpack_public_path__ + "static/img/en.6cd08521.png";